<template>
  <div>
    <span></span>
    <div class='container'>
      <div class='row'>
        <div class='col-md-9'>
          <div v-if="provider" class="provider-link">
            <router-link :to="getProviderLink()">
              <span v-if="provider.firstName">{{ provider.firstName.toLowerCase() }} </span>
              <span v-if="provider.middleName">{{ provider.middleName.toLowerCase() }} </span>
              <span v-if="provider.lastName">{{ provider.lastName.toLowerCase() }}</span>
              <span v-if="provider.title">,{{ provider.title }}</span>
            </router-link>
          </div> <!-- if -->
          <div v-if="isVaccination">
            <span v-if="firstItem.manorg">{{ firstItem.manorg }} </span>
            <span v-if="firstItem.lotnumber">#{{ firstItem.lotnumber }}</span>
          </div>
          <div v-if="instructions">
            {{ instructions }}
          </div>
          <div v-if="isAllergy">
            <span v-if="firstItem.hasallergencode">
              <text-highlight :queries="keywords">
                {{ getCcdDescriptionById(firstItem.codes[0]) }}
              </text-highlight>
              <text-highlight :queries="keywords" class="synonym">
                ({{ firstItem.substance }})
              </text-highlight>
            </span>
            <span v-else>
              <text-highlight :queries="keywords">
                {{ firstItem.substance }}
              </text-highlight>
            </span>
          </div>
          <div v-if="isReport || isDirectives">
            <text-highlight :queries="keywords">
            {{ item.category }}
            </text-highlight>
              <router-link  :to="getReportLink(item.id,0)">
                Link
              </router-link>
          </div>

          <div v-if='isProcedure' class='row'>
            <!-- <watch-button-procedure :procCcd="item.codes[0]" :procIds="item.ids"/> -->
            <!-- <procedure-header :procedure="item" :keywords="keywords" :index="item.ids[0]"/> -->
            <procedure-body :procedure="item" :keywords="keywords" :index="item.ids[0]"/>
          </div>
        </div> <!-- col -->
      </div> <!--row-->
      <div v-if='isProvider'>
        <div v-for="(npiid,npiindex) in this.getFilteredNpis()" :key='npiindex + "npixindex"' class='row'>
          <!-- <text-highlight :queries="keywords">
            {{ providerName(npiid) }}
          </text-highlight>&nbsp; -->
          <router-link :to="getProviderLinkById(npiid)"><text-highlight :queries="keywords">{{ providerName(npiid) }}</text-highlight></router-link> 
        </div>
      </div>

      <div v-for="(cdaid,cdaindex) in item.cdas" :key='cdaindex' class='row'>
        <div class='container'>
          <div class='row'>
            <div class='col-md-4'>
              <span></span>
            </div>
            <div>
              <span v-if="cdaid>0" class="item__link">
                <router-link :to="getCdaLink(cdaid,cdaindex)">
                  {{ cdaList[getCdaIndexById(allData,cdaid)].displayName }}
                </router-link>
              </span>
              <span v-else class="item__link">
                <router-link  :to="getReportLink(item.reports[cdaindex],cdaindex)">
                  {{ reportList[getReportIndexById(allData,item.reports[cdaindex])].displayName }}
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div> <!-- for -->
    </div> <!--container-->
  </div> <!-- if -->
</template>

<script>
import ProcedureHeader from '@/components/private-layouts/procedures/ProcedureHeader';
import ProcedureBody from '@/components/private-layouts/procedures/ProcedureBody';
import WatchButtonProcedure from '@/components/private-layouts/_partials/watch/WatchButtonProcedure';
import types from '@/data/types';
import { getRawItemsByType } from '@/data/getters';
import { getDescByCcd, getCdaIndexById,getReportIndexById } from '@/data/getters.js';
import { mapGetters } from 'vuex';
import {getProviderByNpi, getProvidersFromMedications, getProvidersFromProcedures } from "@/api/getters/provider";
import {
  CDA_FILE_TYPE,
  REPORT_FILE_TYPE
} from '@/config';

export default {
  name: 'item-detail',
  components: {
    'procedure-header': ProcedureHeader,
    'procedure-body': ProcedureBody,
    'watch-button-procedure': WatchButtonProcedure
  },
  props: {
    type: null,
    item: {},
    keywords: Array,
    instance: null
  },
  data() {
    return {
      CDA_FILE_TYPE,
      types,
      provider: null
    }
  },
  created() {
    let providers = [];
    if(this.type === this.types.medication) {
      providers = this.getProvidersFromMedications(this.allData,this.item.ids);
    }
    else if(this.type === this.types.procedures) {
      providers = getProvidersFromProcedures(this.allData,this.item.ids);
    }
    if(providers.length > 0) {
        this.provider = this.getProviderByNpi(this.allData, providers[0]);
    }
    else if(this.type === this.types.procedures && providers.length === 0)
    {
      let reportProviders  = this.item.npis.filter(id => id);
      if(reportProviders.length > 0)
        this.provider = this.getProviderByNpi(this.allData, reportProviders[0]);
    }
    if (this.item && this.item.npi) {
      this.provider = this.getProviderByNpi(this.allData, this.item.npi);
    }
  },
  beforeDestroy() {
    delete this.provider;
    delete this.types;
    delete this.CDA_FILE_TYPE;
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData',
    }),
    ...mapGetters('login/report', {
      reportList: 'getReportList'
    }),
    ...mapGetters('login/cda', {
      cdaList: 'getCdaList'
    }),
    firstItem() {
      getRawItemsByType
      if(!this.item.ids)
        return null;
      let data = getRawItemsByType(this.type,this.allData);
      if(data)
        data = data[this.item.ids[0]];
      return data;
    },
    instructions() {
      if(this.type !== types.medication)
        return null;
      if(this.item.instructions)
        return this.item.instructions[0];
      return null;
    },
    isVaccination() {
      return this.type === types.vaccination;
    },
    isAllergy() {
      return this.type === types.allergy;
    },
    isProcedure() {
      return this.type === types.procedures;
    },
    isProvider() {
      return this.type === types.providers;
    },
    isReport() {
      return this.type === types.reports;
    },
    isDirectives() {
      return this.type === types.directives
    }
  },
  methods: {
    providerName(npiid) {
      let s = '';
      let provider = getProviderByNpi(this.allData,npiid);
      if(provider.lastName)
        s = provider.lastName.toLowerCase() + ',';
      if(provider.firstName)
        s += provider.firstName.toLowerCase() + ' ';
      if(provider.middleName)
        s += provider.middleName.toLowerCase();
      return s;
    },
    getCdaIndexById,
    getReportIndexById,
    getProviderByNpi,
    getProvidersFromMedications,
    getCcdDescriptionById(id) {
      return getDescByCcd(id, this.allData);
    },
    getFilteredNpis() {
      return this.item.npis ? this.item.npis.filter(id => id) : [];
    },
    getSpecialtyLink(specialty) {
      return specialty.toLowerCase().replace(/\s/g, '-');
    },
    getProviderLinkById(npi) {
      let provider = this.getProviderByNpi(this.allData,npi);
      let specialty = this.getSpecialtyLink(provider.specialties[0].name);  
      return {
        name: 'ProviderNavigation',
        params: { specialty, id: provider.id }
        // params: { specialty, id: JSON.stringify(provider.id) }
      }
    },
    getProviderLink() {
      let provider = this.provider;
      let id = provider.id;
      let specialty = this.getSpecialtyLink(provider.specialties[0].name);
      return {
        name: 'ProviderNavigation',
        params: { specialty, id }
        // params: { specialty, id: JSON.stringify(id) }
      }
    },
    hasLink(cdaid,cdaindex) {
      return Boolean(this.item.htmlnames[cdaindex]);
    },
    getReportLink(reportid,cdaindex)
    {
      let item = this.item;
      let type = this.type;
      let allData = this.allData;
      let selectedReport = getReportIndexById(allData,reportid);
      
      let params = {
        fileType: REPORT_FILE_TYPE,
        type,
        selectedReport 
      };
      return {
        name: 'ReportNavigation',
        params
      };
    },
    getCdaLink(cdaid,cdaindex) {
      let item = this.item;
      let type = this.type;
      let allData = this.allData;

      let params = {
        fileTYpe: CDA_FILE_TYPE
      };
      if(type !== 'citation' && this.hasLink(cdaid,cdaindex))
      {
        params = { 
          ...params,
          selectedId: item.ids[cdaindex],
          selectedType : type,
          selectedCda: getCdaIndexById(allData,cdaid)
        };
      }
      else
        params = {
          ...params,
          selectedCda: getCdaIndexById(allData,cdaid)
        };
      return {
        name: 'CdasNavigation',
        params
      };
    }
  }
}
</script>

<style scoped lang="scss">
$color-font: #58595b;

.synonym {
  font-size: 80%;
}
.list__sub-item {
  font-size: 0.85em;
  margin-top: 0.5em;
  color: $color-font;
}
.card {
  width: 100%;
  margin-bottom: 1.0rem;
}
.col-md-9 {
  -webkit-box-flex: 0;
  flex: 0 0 auto;
  max-width: 100%;
  padding-right: 0;
  padding-left: 0;
}
.item__link {
/*  float: right; */
  font-size: 0.85em;
}
</style>
